import React from 'react';
import { Card } from 'reactstrap';

const formatDate = (timestamp) => {
  return new Date(timestamp * 1000).toLocaleDateString();
};

const CustomerDetails = ({ data }) => {
  if (!data) {
    return <div className="text-center">Empty...</div>;
  }

  const { customer, subscriptions, detailedSubscriptions } = data;

  return (
    <div>
      <Card className="card-default mb-1">
        <div className="card-body">
          <h3>Customer Details</h3>
          <hr />
          <div>
            <strong>Customer Id:</strong> {customer.id}
          </div>
          <div>
            <strong>Name:</strong> {customer.name}
          </div>
          <div>
            <strong>Email:</strong> {customer.email}
          </div>
          <div className="pb-4">
            <strong>Currency:</strong> {customer.currency.toUpperCase()}
          </div>
          <div>
            <strong>Active Jobs:</strong> {data.numActiveJobs}
          </div>
          <div>
            <strong>Active Users:</strong> {data.numActiveUsers}
          </div>
          <div className="pb-4 pt-2">
            <a
              href="https://billing.stripe.com/p/login/test_00g8zm35D4jWfTO8ww"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here to manage subscriptions
            </a>
          </div>
          <h3>Subscription Details</h3>
          <hr />
          {/* {subscriptions.length === 0 ? (
            <>
              <h6 className="my-3">Currently you don't have any active subscriptions</h6>
            </>
          ) : (
            subscriptions?.map((subscription, index) => (
              <div key={index}>
                <ul className="list-group list-group-flush">
                  {subscription.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="list-group-item">
                      <h4>Product: {item.product.name}</h4>
                      <strong>Product Id:</strong> {item.product.id}
                      <br />
                      <strong>Price:</strong> {item.amount / 100} {item.currency.toUpperCase()}
                    </li>
                  ))}
                </ul>
                <div className="card-text">
                  <strong>Status:</strong> {subscription.subscription.status}
                </div>
                <div className="card-text">
                  <strong>Period:</strong> {formatDate(subscription.subscription.current_period_start)} -{' '}
                  {formatDate(subscription.subscription.current_period_end)}
                </div>
                <div className="card-text">
                  <strong>Subscription Id:</strong> {subscription.subscription.id}
                </div>
                <br />
              </div>
            ))
          )} */}
          {detailedSubscriptions?.map(({ subscription, items }) => (
            <div key={subscription.id}>
              <div>
                <div>
                  <strong>Subscription Id:</strong> {subscription.id} - {subscription.status.toUpperCase()}
                </div>
                <div>
                  <strong>Currency:</strong> {subscription.currency.toUpperCase()}
                </div>
                <div>
                  <strong>Billing Cycle Anchor:</strong> {formatDate(subscription.billing_cycle_anchor)}
                </div>
                <div>
                  <strong>Current Period:</strong> {formatDate(subscription.current_period_start * 1000)} -{' '}
                  {formatDate(subscription.current_period_end * 1000)}
                </div>
                <div className="pb-4">
                  <strong>Canceled At: </strong>
                  {subscription.canceled_at ? formatDate(subscription.canceled_at * 1000) : 'N/A'}
                </div>

                <h5>Items</h5>
                <ul className="list-group list-group-flush">
                  {items.map((item) => (
                    <li key={item.item.id} className="list-group-item">
                      <div>
                        <strong>Product Id:</strong> {item.item.id}
                      </div>
                      <div>
                        <strong>Product Name:</strong> {item.product.name}
                      </div>
                      <div>
                        <strong>Price:</strong>
                        {(item.amount / 100).toFixed(2)} {item.currency.toUpperCase()}
                      </div>
                      {/* <br />
                      Quantity: {item.item.quantity} */}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default CustomerDetails;
